/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQuerySortCriteria {
    getFixupPrototypeFunction() { return WorkloadQuerySortCriteria.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQuerySortCriteria>): WorkloadQuerySortCriteria {
        let obj = Object.assign(new WorkloadQuerySortCriteria(), model);
        WorkloadQuerySortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQuerySortCriteria>): WorkloadQuerySortCriteria {
        if (!model) return null;
        return WorkloadQuerySortCriteria.newInstance(<WorkloadQuerySortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQuerySortCriteria) {
        if (!obj) return;

        models.WorkloadQuerySortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQuerySortCriteria): boolean {
        Object.setPrototypeOf(obj, WorkloadQuerySortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.WorkloadQuerySortColumn;

    ascending: boolean;

}
